class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.summaries = document.querySelectorAll('summary');

    this.summaries.forEach((summary) => {
      summary.addEventListener('click', this.onClick.bind(this));
    });
    
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.closest('header-menu')) this.close();
    });
  }

  onClick(event) {
    // if(this.closest('header-menu')) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   event.stopImmediatePropagation();
    //   return;
    // }
  }

  onToggle(event) {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // this.summaries = document.querySelectorAll('summary');

    // this.summaries.forEach((summary) => {
    //   summary.addEventListener('click', this.onSummaryClick.bind(this));
    // });
  }

  // onSummaryClick(event) {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   // this.mainDetailsToggle.open = !this.mainDetailsToggle.open;
  // }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
